import React, { PropsWithChildren } from 'react';
import { styled } from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';
import { GridTableContext } from '../../contexts';
import { TableRowStyled } from './table.style';

export const EmptyCell = styled(TableCell)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  padding: theme.spacing(1),
  textAlign: 'center',
  fontStyle: 'italic'
}));

export function EmptyRow({ children }: PropsWithChildren): JSX.Element {
  const {
    instance: { headerGroups }
  } = React.useContext(GridTableContext);
  return (
    <TableRowStyled>
      <EmptyCell colSpan={headerGroups[0].headers.length}>{children}</EmptyCell>
    </TableRowStyled>
  );
}
